import CheckBoxOutlineBlank from "@mui/icons-material/CheckBoxOutlineBlank";
import Square from "@mui/icons-material/Square";
import { Chip, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

/**
 * Whether an assessment is definitive, as a pill whose filled or outlined
 * square tells the two apart at a glance.
 */
export const AssessmentKindChip = ({ definitive }: { definitive: boolean }) => {
  const { t } = useTranslation();
  const tonal = useTheme().palette.tonal;
  const swatch = definitive ? tonal.primary : tonal.neutral;
  const Icon = definitive ? Square : CheckBoxOutlineBlank;

  return (
    <Chip
      size="small"
      icon={<Icon aria-hidden />}
      label={
        definitive
          ? t("personPage.assessments.definitive")
          : t("personPage.assessments.nonDefinitive")
      }
      sx={{
        fontWeight: 600,
        bgcolor: swatch.background,
        color: swatch.color,
        "& .MuiChip-icon": { color: swatch.icon },
      }}
    />
  );
};
